import { getSessionData } from '../../api';
import { sessionConstants } from '../constants';

export const SESSION_SET_AUTHENTICATION = 'Session/set';
export const SESSION_RESET_AUTHENTICATION = 'Session/reset';
export const SESSION_SET_LOADING = 'Session/loading';

export const loadingSession = loading => ({
  type: SESSION_SET_LOADING,
  payload: { loading },
});

export const setSessionData = session => ({
  type: SESSION_SET_AUTHENTICATION,
  payload: { session },
});

export const unsetSessionData = logoutReason => ({
  type: SESSION_RESET_AUTHENTICATION,
  payload: { logoutReason },
});

export const killSession = logoutReason => dispatch => {
  dispatch(loadingSession(true));
  dispatch(unsetSessionData(logoutReason));
};

export const initSession =
  (isBroker = false) =>
  async dispatch => {
    dispatch(loadingSession(true));
    let sessionData;

    if (isBroker) {
      sessionData = {
        success: true,
        data: {
          accessTokenRemainingSeconds: 300,
          refreshTokenRemainingSeconds: 900,
          role: 'broker',
        },
      };
    } else {
      sessionData = await getSessionData();
    }
    //
    if (sessionData === null) {
      // redirect here
      window.location.replace('/sales/api/business/auth/employee');
    }

    if (sessionData === null) {
      dispatch(killSession(sessionConstants.LOGOUT_REASON.MANUAL));
    } else {
      dispatch(setSessionData(sessionData));
    }
  };
